import { List } from "antd";
import styled from "styled-components";

export const ServiceListItem = styled(List.Item)({
  "&.ant-list-item": {
    paddingInline: 0,
  },

  "& .ant-list-item-action": {
    display: "flex",
    alignItems: "center",
  },

  "& .ant-list-item-meta": {
    marginRight: 16,

    "& .ant-list-item-meta-content": {
      "& .ant-list-item-meta-description": {
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
  },
});
